import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { Menu } from 'antd';
import { UserOutlined } from '@ant-design/icons';

import { EmptyHeader } from 'components';

import { logout, selectors } from 'state';

import { useDevTabsAccess } from './useDevTabsAccess';

const MyHeader: React.FC = () => {
  const dispatch = useDispatch();
  const username = useSelector(selectors.username);
  const selectedPerson = useSelector(selectors.selectedPerson);
  // Development Plan + Games menu items: shown to trainees the admin has granted
  // access (per-user `can_see_devplan`), OR to developers via `?devTabs=1`.
  const devOverride = useDevTabsAccess();
  const canSeeDevplan = useSelector(selectors.canSeeDevplan);
  const showDevplanTabs = canSeeDevplan || devOverride;

  return (
    <EmptyHeader defaultKey="dashboard">
      <Menu.Item key="dashboard">
        <Link to={`/dashboard`}>Sessions</Link>
      </Menu.Item>
      {showDevplanTabs && (
        <Menu.Item key="development-plan">
          <Link to={`/dashboard/development-plan`}>Development Plan</Link>
        </Menu.Item>
      )}
      {showDevplanTabs && (
        <Menu.Item key="games">
          <Link to={`/dashboard/games`}>Games</Link>
        </Menu.Item>
      )}
      {/* Shapes tab hidden — layout-comparison sandbox. Code kept: the view in
          ./Shapes and the /dashboard/shapes route in ./index.tsx are untouched.
          Uncomment to show it again.
      {devOverride && (
        <Menu.Item key="shapes">
          <Link to={`/dashboard/shapes`}>Shapes</Link>
        </Menu.Item>
      )}
      */}
      <Menu.SubMenu
        title={
          <>
            <UserOutlined />
            {selectedPerson?.name || username}
          </>
        }
        style={{ marginLeft: 'auto' }}
      >
        <Menu.Item onClick={() => dispatch(logout({}))}>Logout</Menu.Item>
      </Menu.SubMenu>
    </EmptyHeader>
  );
};

export default MyHeader;
